// Note List Page
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NoteList from '../components/NoteList';
import { apiClient } from '../services/api';
import type { Note } from '../types/note';

export default function NoteListPage() {
  const navigate = useNavigate();
  const [notes, setNotes] = useState<Note[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadNotes();
  }, []);

  const loadNotes = async () => {
    setIsLoading(true);
    const result = await apiClient.getNotes();
    if (result.data) {
      setNotes(result.data.notes);
    }
    setIsLoading(false);
  };

  const handleNoteClick = (note: Note) => {
    navigate(`/notes/${note.id}`);
  };

  const handleDeleteNote = async (id: string) => {
    if (confirm('Are you sure you want to delete this note?')) {
      const result = await apiClient.deleteNote(id);
      if (result.data) {
        setNotes(notes.filter((n) => n.id !== id));
      }
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">My Notes</h2>
        <button
          onClick={() => navigate('/notes/new')}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors"
        >
          + New Note
        </button>
      </div>

      {isLoading ? (
        <div className="text-center py-12 text-gray-500">Loading...</div>
      ) : (
        <NoteList notes={notes} onNoteClick={handleNoteClick} onDeleteNote={handleDeleteNote} />
      )}
    </>
  );
}
